import { observer } from 'mobx-react'
import { Routes, Route } from 'react-router-dom'
import { Layout } from 'antd'
import LandingPage from './LandingPage'
import CollectionsPage from './CollectionsPage'
import MyWalletPage from './MyWalletPage'
import NftPage from './NftPage'
import { useEffect, useState } from 'react'
import { NFTHeader } from '../components/NFTHeader'
import { MobileMenu } from '../components/MobileMenu'
import { getWindowSize } from '../utils/windowSize'
import CollectionPage from './CollectionPage'

const IndexPage = observer(() => {
  const [windowSize, setWindowSize] = useState(getWindowSize())
  const handleWindowResize = (): void => {
    setWindowSize(getWindowSize())
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize)
    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  return (
    <Layout>
      {windowSize.innerWidth < 992 &&
        <MobileMenu/>
      }
      {
        windowSize.innerWidth >= 992 &&
        <NFTHeader/>
      }
      <Routes>
        <Route path="/" element={<LandingPage/>}/>
        <Route path="/collection" element={<CollectionPage/>}/>
        <Route path="/collection/:address" element={<CollectionPage/>}/>
        <Route path="/collections" element={<CollectionsPage/>}/>
        <Route path="/my-wallet" element={<MyWalletPage/>}/>
        <Route path="/nfts/:collectionAddress/:tokenId" element={<NftPage/>}/>
      </Routes>
    </Layout>
  )
})

export default IndexPage
